import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import DateFilter from "./date-filter";
import { useEffect, useState } from "react";
import FilterColumn from "./filter-column";
import { TFilter, TMetaData, TVisitorsDataTable } from "types/analytics.types";
import FilterOptions from "./filter-options";
import { getVisitorsAnalyticsData } from "apis/analytics/visitors/datatable";
import { FilterContainer } from "../index.styles";

const VisitorsFilter = ({
  metadata,
  onChangeColumn,
  onChangeData,
  onChangeFilter,
  onChangeCurrentPage,
  onChangeTotalPage,
  onChangeDate,
}: {
  metadata?: TMetaData[];
  onChangeColumn?: (value: TMetaData[]) => void;
  onChangeData?: (value: TVisitorsDataTable[]) => void;
  onChangeFilter?: (value: TFilter[]) => void;
  onChangeTotalPage?: (value: number) => void;
  onChangeCurrentPage?: (value: number) => void;
  onChangeDate?: (start: string, end: string) => void;
}) => {
  const getAdjustedDate = (unit: string, n: number): Date => {
    const date = new Date();
    if (unit === "m") {
      date.setMonth(date.getMonth() + n);
    } else {
      date.setDate(date.getDate() + n);
    }
    return date;
  };

  const [startDate, setStartDate] = useState<Date>(getAdjustedDate("d", -31));
  const [endDate, setEndDate] = useState<Date>(getAdjustedDate("d", -1));
  const [selectedMeta, setSelectedMeta] = useState<TMetaData[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<TFilter[]>([]);

  const validateFilter = () => {
    // 필터가 비어있는 경우 제거
    const filteredEmpty = selectedFilters.filter((filter) => {
      if (filter.value === undefined || filter.value.length < 1) return false;
      if (filter.operator === undefined) return false;
      else return true;
    });
    setSelectedFilters(filteredEmpty);
    return filteredEmpty;
  };

  const onSearch = async () => {
    const filters = validateFilter();
    const res = await getVisitorsAnalyticsData(
      1,
      { start: startDate.toDateString(), end: endDate.toDateString() },
      filters
    );
    onChangeColumn?.(selectedMeta);
    onChangeData?.(res.data?.visitorsDashboards ?? []);
    onChangeFilter?.(filters);
    onChangeTotalPage?.(res.data?.totalPageNumber ?? 0);
    onChangeCurrentPage?.(1);
  };

  return (
    <FilterContainer>
      <div className="filter-box">
        <div className="filter-form">
          <div className="label">
            <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
              기간
            </UI.Typography>
          </div>
          <DateFilter
            startDate={startDate}
            endDate={endDate}
            onChange={(start, end) => {
              onChangeDate?.(start.toDateString(), end.toDateString());
              setStartDate(start);
              setEndDate(end);
            }}
            maxDate={getAdjustedDate("d", -1)}
          />
        </div>
        <div className="filter-form" style={{ alignItems: "flex-start" }}>
          <div className="label">
            <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
              항목
            </UI.Typography>
          </div>
          <FilterColumn
            metadata={metadata ?? []}
            selected={selectedMeta}
            onChange={(value: TMetaData[]) => {
              setSelectedMeta(value);
            }}
          />
        </div>
        <div className="filter-form" style={{}}>
          <div className="label">
            <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
              필터
            </UI.Typography>
          </div>
          <FilterOptions metadata={selectedMeta} onChange={setSelectedFilters} filters={selectedFilters} />
        </div>
      </div>
      <UI.Button primary={true} title="조회하기" size="large" onClick={onSearch} />
    </FilterContainer>
  );
};

export default VisitorsFilter;
